// LIBRERIE
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

//COMPONENTI
import ServerError from "../Error/ServerError";
import LoadingIndicator from "../Loaders/LoadingIndicator";
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import WidgetContacts from "../Widgets/WidgetContacts/WidgetContacts";
import WidgetPartners from "../Widgets/WidgetPartners/WidgetPartners";

//HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import appConfig from "../../config/appConfig";

//img


interface TrainingProps {
    agencyId: number;
}

const Partners: React.FC<TrainingProps> = ({ agencyId }) => {
    const { t } = useTranslation();
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);

    const allPartnersForWidget = appConfig.content.partners;


    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;

    return(
        <>
            <Helmet>
                <title>{t('partnersPage.pageTitle')} | {agency?.agencyName || 'Agenzia Immobiliare'}</title>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Lato:wght@300;400&display=swap" rel="stylesheet" />
            </Helmet>

            <SubHeaderDefault title={t('partnersPage.pageTitle')} isSeo={false} />

            <section id="page" className="space-ptb">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-8 col-xl-9">
                            <p dangerouslySetInnerHTML={{ __html: t('partnersPage.para1') as string }}></p>
                            <WidgetPartners partners={allPartnersForWidget} />
                        </div>
                        <div id="sidebar" className="col-12 col-md-4 col-xl-3">
                            <img src={''}  className="img-fluid mb-5 mx-auto d-block" alt="abitare partners" title="Salvadori partners" />
                            <WidgetContacts
                                agencyDataAddress={agency?.address_details?.address ?? ''}
                                agencyDataCity={agency?.address_details?.city_name ?? ''}
                                agencyDataComuneCapoluogo={agency?.address_details?.city_name === agency?.address_details?.province_name}
                                agencyDataProvinciaSigla={agency?.address_details?.sigla ?? ''}
                                agencyDataEmail={appConfig.agency.agencyEmail}
                                agencyDataEmailShow={appConfig.ui.agencyWidget.showEmail}
                                agencyDataPhone1={agency?.phone1 ?? ''}
                                agencyDataPhone2={agency?.phone2 ?? ''}
                                agencyDataInternationalPrefix={appConfig.agency.intlPrefix ?? '+39'}
                                agencyDataMobile={agency?.mobile ?? ''}
                                agencyDataMobile2={agency?.mobile2 ?? ''}
                                agencySocialShow={appConfig.ui.agencyWidget.showSocialLinks}
                                agencyDataWhatsapp={appConfig.socialLinks.whatsapp}
                                agencyDataFacebook={appConfig.socialLinks.facebook}
                                agencyDataInstagram={appConfig.socialLinks.instagram}
                                agencyDataTwitter={appConfig.socialLinks.twitter}
                                agencyDataLinkedin={appConfig.socialLinks.linkedin}
                                agencyDataPinterest={appConfig.socialLinks.pinterest}
                                agencyDataYoutube={appConfig.socialLinks.youtube}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Partners;